import fetch from '@/api/fetch';

const commonParams = {
  sysParam: {
    appKey: 1213,
    format: 'JSON',
    locale: 'zh_CN',
    sign: 'ajsdfkjdlkfgjl;kwjdfg',
  },
};

// 获取角色列表
export function getRoleList(params) {
  return fetch({
    url: '/baccount/workbench/role/list',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 获取全部角色
export function getAllRole() {
  return fetch({
    url: '/baccount/workbench/role/all',
    method: 'post',
    data: commonParams,
  });
}

// 获取除管理员以外的角色
export function getNormalRoles() {
  return fetch({
    url: '/baccount/workbench/role/allocatable',
    method: 'post',
    data: commonParams,
  });
}

// 删除角色
export function deleteRole(params) {
  return fetch({
    url: '/baccount/workbench/role/delete',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 添加角色
export function addRole(params) {
  return fetch({
    url: '/baccount/workbench/role/add',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 查询角色信息
export function getRoleDetail(params) {
  return fetch({
    url: '/baccount/workbench/role/info',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 更新角色
export function updateRole(params) {
  return fetch({
    url: '/baccount/workbench/role/update',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 获取权限树
export function getAuthList() {
  return fetch({
    url: '/baccount/workbench/perm/list',
    method: 'post',
    data: commonParams,
  });
}

// 员工授权
export function authStaff(params) {
  return fetch({
    url: '/baccount/workbench/role/employee',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}
